import React from 'react'

import { ComponentData } from '../table_component'

export const NO: React.FC<ComponentData> = ({ rowIndex }) => {
  return <span>{rowIndex + 1}</span>
}
